<template>
  <div class="dataset-base-page col-block width-full">
    <div class="dataset-form-container col-block width-full">
      <template v-if="(form || {}).roleSelect">
        <customForm
          :layoutType="'grid'"
          :groupCount="6"
          :init="dataset"
          :alerts="alerts"
          :scope="scope"
          :forms="formOptions['field0']"
          @change="(result, validate, errors) => formOnChange('field0', result, validate, errors)"
        >
          <template slot="user_id" slot-scope="props">
            <div :name="props" class="input-group" :style="{ width: '100%', padding: 0 }">
              <inputTag
                :style="{
                  width: '100%'
                }"
                :inputStyle="{
                  'padding-right': '40px'
                }"
                :init="(userOptions.find(option => option.value === result.user_id) || {}).title"
                :emptyDisplay="true"
                :disabled="false"
                :placeholder="'all'"
                :tags="users"
                :prefix="'(?:^)'"
                :target="'^(.*?)$'"
                :replace="user => [user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : '')"
                :filter="content => user => content && ([user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : '')).match(new RegExp(content.replace(/(\(|\)|\[|\]|\{|\}|\\)/g, '\\$1'), 'i'))"
                :tagDisplay="user => [user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : '')"
                @send="content => onEvent('send', content)"
                @tag="content => onEvent('tag', content)"
              ></inputTag>
            </div>
          </template>
        </customForm>
      </template>
      <customForm
        :layoutType="'grid'"
        :groupCount="6"
        :init="dataset"
        :alerts="alerts"
        :scope="scope"
        :forms="formOptions['field1']"
        @change="(result, validate, errors) => formOnChange('field1', result, validate, errors)"
      >
        <template slot="_TAG" slot-scope="props">
          <div class="_TAG input-group" :name="props">
            <dataTag
              :style="{
                width: '100%'
              }"
              :disabled="false"
              :placeholder="'Name of tags'/* ___ */"
              :needInfo="false"
              :init="query['tag']"
              :data="tag['tag']"
              :tagDisplay="tag => tag"
              :emptyMsg="''/* ___ */"
              :replace="(tag, content) => tag"
              @input="content => { query['tag'] = content }"
              @tag="tag => { query['tag'] = tag; curTag['tag'] = tag }"
              @send="content => addTag('tag')"
            ></dataTag>
          </div>
        </template>
        <template slot="_TAGS" slot-scope="props">
          <div class="_TAGS row-block stretch" :name="props">
            <button type="button" class="white-gray-button circle-button" :disabled="!query['tag']" @click="e => addTag('tag', 'button')">
              <span>{{ 'Add'/* ___ */ }}</span>
            </button>
            <div :style="{ width: '20px' }"></div>
            <div class="tag-list-container row-block flex-start flex-wrap shrink">
              <div class="tag-block row-block" v-for="(tag, index) in tags['tag']" :key="index">
                <div class="tag-title">{{ tag }}</div>
                <div :style="{ width: '5px' }"></div>
                <img class="tag-remove-icon" :src="require('../../assets/images/remove-tag-icon.svg')" alt="" @click="e => tags['tag'].splice(index, 1)">
              </div>
            </div>
            <div :style="{ flex: 1 }"></div>
          </div>
        </template>
      </customForm>
    </div>
    <div :style="{ height: '15px' }"></div>
    <div class="dataset-picture-field col-block flex-start">
      <div class="dataset-picture-title">{{ 'Picture of dataset'/* ___ */ }}</div>
      <div :style="{ height: '7px' }"></div>
      <div class="dataset-picture-container row-block flex-start flex-wrap">
        <div class="dataset-picture-list-container row-block flex-start flex-wrap">
          <div class="dataset-picture-block" v-for="(picture, index) in pictures" :key="index" @click="e => selectedPictureID = picture.id">
            <div class="dataset-picture" :style="{ 'background-image': 'url(' + picture.url + ')' }"></div>
            <div class="dataset-picture-radio-icon icon-block" :style="{ '--size': '20px' }">
              <img :src="selectedPictureID === picture.id ? require('../../assets/images/radio-true.svg') : require('../../assets/images/radio-false.svg')" alt="">
            </div>
          </div>
        </div>
        <div class="custom-picture-container col-block flex-start">
          <div class="custom-picture-title-container row-block" :class="{ disabled: !customPicture }" @click="e => customPicture && (selectedPictureID = 'custom')">
            <div class="custom-picture-radio-icon icon-block" :style="{ '--size': '20px' }">
              <img :src="selectedPictureID === 'custom' ? require('../../assets/images/radio-true.svg') : require('../../assets/images/radio-false.svg')" alt="">
            </div>
            <div :style="{ width: '10px' }"></div>
            <div class="custom-picture-title">{{ 'Custom picture'/* ___ */ }}</div>
          </div>
          <div :style="{ height: '10px' }"></div>
          <div class="custom-picture-main-container col-block">
            <div v-if="customPicture" class="custom-picture-image-block">
              <div class="custom-picture-image mask" :style="{ 'background-image': 'url(' + customPicture.url + ')' }"></div>
              <div class="custom-picture-image" :style="{ 'background-image': 'url(' + customPicture.url + ')' }"></div>
            </div>
            <div class="mask">
              <input v-show="false" type="file" id="custom-picture" accept="image/*" @change="e => fileTypeCheck(e, e => selectCustomPicture(e), () => addToast('error', 'Please upload image file'/* ___ */))">
              <label for="custom-picture"></label>
              <button class="white-gray-button circle-button">
                <span>{{ 'Select'/* ___ */ }}</span>
              </button>
            </div>
          </div>
        </div>
        <div :style="{ flex: 1 }"></div>
      </div>
    </div>
    <template v-if="(form || {}).sampleSelect">
      <hr class="custom" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '15px' }">
      <div class="dataset-sample-container col-block width-full">
        <div class="dataset-sample-title-container row-block">
          <borCor
            :display="!!(alerts['sample'] && alerts['sample'].type === 'error')"
            :background="'white'"
            :border="'#FA3D3D'"
            :radius="'3px'"
            :translate="'-120px 0px'"
            :blockStyle="{
              padding: '5px 20px'
            }"
          >
            <div slot="trigger">
              <div class="dataset-sample-title-block row-block" :class="{ alert: alerts['sample'] && alerts['sample'].type === 'error' }">
                <div class="dataset-sample-title">{{ 'Samples of the dataset'/* ___ */ }}<span class="alert"> *</span></div>
                <div :style="{ width: '10px' }"></div>
                <div class="dataset-sample-information">{{ '(' + selectedSampleSize + ' ' + (selectedSampleSize > 1 ? 'samples' : 'sample') + ' selected)'/* ___ */ }}</div>
                <div :style="{ width: '20px' }"></div>
                <div class="dataset-sample-option-container row-block">
                  <button class="white-gray-button circle-button" :disabled="sample.listType !== 'case'" @click="e => sampleOpenDatasetSelectCase()">
                    <span>{{ 'Select'/* ___ */ }}</span>
                  </button>
                </div>
              </div>
            </div>
            <div slot="content">
              <div class="dataset-sample-alert">{{ (alerts['sample'] || {}).msg }}</div>
            </div>
          </borCor>
          <div class="dataset-sample-view-type-container row-block">
            <div class="dataset-sample-view-type-title" :class="{ active: sample.viewType === 'detail' }">{{ 'Detail view'/* ___ */ }}</div>
            <switchButton
              :disabled="false"
              :active="true"
              :checked="sample.viewType === 'list'"
              @input="c => sample.viewType = c ? 'list' : 'detail'"
            ></switchButton>
            <div class="dataset-sample-view-type-title" :class="{ active: sample.viewType === 'list' }">{{ 'List view'/* ___ */ }}</div>
          </div>
        </div>
        <div :style="{ height: '15px' }"></div>
        <hr class="custom" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '0' }">
        <div class="dataset-sample-list-container col-block width-full">
          <div class="dataset-sample-list-option-container row-block">
            <div class="dataset-sample-list-tab-list-container row-block">
              <div class="tab-field row-block height-full" :class="{ active: option.value === sample.listType }" v-for="(option, tindex) in sampleListOptions" :key="tindex" @click="e => sample.listType = option.value">
                <div class="tab-container col-block">
                  <div :style="{ flex: 1 }"></div>
                  <div class="tab-block row-block">
                    <div class="tab-title">{{ option.title }}</div>
                  </div>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
            </div>
            <div class="dataset-sample-list-search-container input-group" :style="{ width: '280px' }">
              <input type="text" :placeholder="{ case: 'Case ID of the samples'/* ___ */, dataset: 'Keywords of dataset'/* ___ */ }[sample.listType]" v-model="sample.query" :style="{ 'padding-right': '40px' }">
              <img :src="require('../../assets/images/search-solid.svg')" alt="">
            </div>
          </div>
        </div>
        <div class="dataset-sample-table-field col-block width-full">
          <template v-for="(sampleOption) in sampleListOptions">
            <div class="dataset-sample-table-container custom-table" :class="{ 'auto-height': false, active: sample.listType === sampleOption.value }" :key="sampleOption.value">
              <div class="table-field col-block" :style="{ width: '100%' }">
                <div class="table-container col-block">
                  <div class="thead">
                    <div class="tr row-block">
                      <div
                        v-for="(option, index) in sampleTableOptions[sampleOption.value].filter(option => option.show !== false)"
                        :key="index"
                        class="th row-block"
                        :class="[{ sortable: option.sortMap !== null }, (option.class || (() => []))(null, -1, null)]"
                        :style="option.width ? { width: option.width + 'px' } : { flex: 1 }"
                        @click="e => !sample.sort[sampleOption.value].disabled && option.sortMap !== null && sampleTableSortBy(option.sortValue || option.value, sampleOption.value)"
                      >
                        <template v-if="option.value === '_SELECT'">
                          <div class="_SELECT center-block">
                            <img :src="sample.results[sampleOption.value].length ? !sampleFiltedDatas[sampleOption.value].some(data => !sampleSelectedDataMap[sampleOption.value][data.id]) ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-minus.svg') : require('../../assets/images/checkbox-false.svg')" alt="" @click="e => sampleTableOnSelect(sampleOption.value, null, 'all')">
                          </div>
                        </template>
                        <template v-else>
                          <span class="ellipsis">{{ option.title }}</span>
                          <template v-if="option.sortMap !== null">
                            <div :style="{ width: '5px' }"></div>
                            <i :class="['fa', 'fa-sort' + (sample.sort[sampleOption.value].order[sample.sort[sampleOption.value].value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true"></i>
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <scrollBottom
                  :ref="'custom-table-scroll-' + sampleOption.value"
                  class="table-group-container col-block width-full"
                  :containerKey="sampleOption.value"
                  :deviation="800"
                  :onScrollBottom="() => sampleSearchDatas(false, sampleOption.value)"
                >
                  <div v-if="sample.pageData.total[sampleOption.value] || Object.keys(sampleSelectedDataMap[sampleOption.value]).length" class="col-block">
                    <div class="table-container col-block" v-for="(group, gindex) in sampleTableDatas[sampleOption.value]" :key="gindex">
                      <div class="tbody" :class="{ 'list-view': ['list'].includes(sample.viewType) }">
                        <div class="tr group row-block" :class="{ selected: false }" :style="group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' }">
                          <a class="container-block row-block">
                            <div class="bar"></div>
                            <div
                              v-for="(option, index) in sampleTableOptions[sampleOption.value].filter(option => option.show !== false)"
                              :key="index"
                              class="td row-block"
                              :class="(option.class || (() => []))(group[option.gValue], gindex, group)"
                              :style="option.width ? { width: option.width - (!sampleTableOptions[sampleOption.value][index + 1] && sample.tableOverflow[sampleOption.value] ? scrollbarSize : 0) + 'px' } : { flex: 1 }"
                            >
                              <template>
                                <span
                                  :style="(option.gstyle || (() => ({})))(group[option.gValue], gindex, group)"
                                  :title="((option.gdisplay || (x => x))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')"
                                  v-html="(option.gdisplay || (x => x))(group[option.gValue], gindex, group) || option.gempty || ''"
                                ></span>
                              </template>
                              <template v-if="option.sortMap !== null && (option.class || (() => []))(group[option.gValue], gindex, group).includes('center') && !(option.class || (() => []))(group[option.gValue], gindex, group).includes('auto-width')">
                                <div :style="{ width: '5px' }"></div>
                                <i :class="['fa', 'fa-sort' + (sample.sort[sampleOption.value].order[sample.sort[sampleOption.value].value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                              </template>
                            </div>
                          </a>
                        </div>
                        <div class="tr col-block" :class="{ selectable: false, selected: false }" v-for="(data, dindex) in group.datas" :key="dindex">
                          <a v-if="['detail'].includes(sample.viewType)" class="container-block row-block" :style="{ flex: 1 }">
                            <div class="bar"></div>
                            <div
                              v-for="(option, index) in sampleTableOptions[sampleOption.value].filter(option => option.show !== false)"
                              :key="index"
                              class="td row-block"
                              :class="(option.class || (() => []))(data[option.value], dindex, data)"
                              :style="option.width ? { width: option.width - (!sampleTableOptions[sampleOption.value][index + 1] && sample.tableOverflow[sampleOption.value] ? scrollbarSize : 0) + 'px' } : { flex: 1 }"
                            >
                              <template v-if="option.value === '_SELECT'">
                                <div class="_SELECT center-block">
                                  <img :src="data.selected ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-false.svg')" alt="" @click="e => sampleTableOnSelect(sampleOption.value, [data], !data.selected)">
                                </div>
                              </template>
                              <template v-else-if="option.value === '_DETAIL'">
                                <div class="_DETAIL center-block">
                                  <img :src="require('../../assets/images/dataset-detail-icon.svg')" alt="" @click="e => sampleOpenDatasetDetail(data)">
                                </div>
                              </template>
                              <template v-else>
                                <span
                                  :style="(option.style || (() => ({})))(data[option.value], dindex, data)"
                                  :title="((option.display || (x => x))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')"
                                  v-html="(option.display || (x => x))(data[option.value], dindex, data) || option.empty || '- -'"
                                ></span>
                              </template>
                              <template v-if="option.sortMap !== null && (option.class || (() => []))(data[option.value], dindex, data).includes('center') && !(option.class || (() => []))(data[option.value], dindex, data).includes('auto-width')">
                                <div :style="{ width: '5px' }"></div>
                                <i :class="['fa', 'fa-sort' + (sample.sort[sampleOption.value].order[sample.sort[sampleOption.value].value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                              </template>
                            </div>
                          </a>
                          <div v-else class="list-block row-block">
                            <img :src="data.selected ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-false.svg')" alt="" @click="e => sampleTableOnSelect(sampleOption.value, [data], !data.selected)">
                            <span
                              class="ellipsis"
                              :style="{ flex: 1 }"
                              :title="((sampleTableOptions[sampleOption.value][1].display || (x => x))(data[sampleTableOptions[sampleOption.value][1].value], dindex, data) || '').replace(/\<.+?\>/g, '')"
                              v-html="(sampleTableOptions[sampleOption.value][1].display || (x => x))(data[sampleTableOptions[sampleOption.value][1].value], dindex, data) || sampleTableOptions[sampleOption.value][1].empty || '- -'"
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="table-empty-container col-block">
                    <div :style="{ flex:1 }"></div>
                    <div class="table-empty-content" :class="[sampleOption.value]">{{ sample.emptyText[sampleOption.value] || '' }}</div>
                    <div :style="{ flex:1 }"></div>
                  </div>
                </scrollBottom>
                <div class="table-page-container row-block sub-shadow" :style="{ height: '50px' }">
                  <div class="options-container input-group row-block" :style="{ flex: 1 }">
                    <div :style="{ flex: 1 }"></div>
                    <div class="display-container row-block">
                      <div class="display-title">{{ 'Items per page'/* ___ */ }}</div>
                      <div :style="{ width: '10px' }"></div>
                      <div>
                        <select class="display" v-model="sample.pageData.display[sample.listType]">
                          <option value="20">20</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="200">200</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="options-container input-group row-block">
                    <pageButtons
                      :default="sample.pageData.selectedPage[sample.listType]"
                      :display="sample.pageData.display[sample.listType] - 0"
                      :total="totalPage * sample.pageData.display[sample.listType]"
                      :buttonRange="sample.pageData.buttonRange[sample.listType]"
                      @selectPage="page => { sample.pageData.selectedPage[sample.listType] = page }"
                      :style="{ flex: 1 }"
                    ></pageButtons>
                  </div>
                  <div class="options-container input-group row-block" :style="{ flex: 1 }">
                    <div class="jump-container row-block">
                      <div class="jump-title">{{ 'Go to'/* ___ */ }}</div>
                      <div :style="{ width: '10px' }"></div>
                      <select class="jump" v-model="sample.pageData.pageJumpTo[sample.listType]" @change="e => sample.pageData.selectedPage[sample.listType] = sample.pageData.pageJumpTo[sample.listType] - 0">
                        <option v-for="(value, index) in (new Array(totalPage[sample.listType])).fill('').map((_, i) => i + 1)" :key="index" :value="value">{{ value }}</option>
                      </select>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  getManagedUsers,
  getDatasetPictureFile,
  getDatasetPictureFiles,
  getFullAccessDatasets,
  getDatasetExistingState,
  getCreateDatasetCases,
  getDatasetCases
} from '../../api'
import { API_ROOT } from '../../api/config'
import customForm from '../../components/tool/customForm.vue'
import inputTag from '../../components/tool/inputTag.vue'
import dataTag from '../../components/tool/dataTag.vue'
import switchButton from '../../components/tool/switchButton.vue'
import pageButtons from '../../components/tool/pageButtons.vue'
import scrollBottom from '../../components/tool/scrollBottom.vue'
import borCor from '../../components/tool/newBorCor.vue'
import routeLoading from '../../mixins/routeLoading.vue'
import responsitive from '../../mixins/responsitive.vue'
import customTimeout from '../../mixins/customTimeout.vue'
import { datasetPipelineMap } from '../../constants/global/data'
import { dateFormat, toPriceString, fileTypeCheck, imageReader, groupBy, sortData } from '../../constants/global/util'

export default {
  components: {
    customForm,
    inputTag,
    dataTag,
    switchButton,
    pageButtons,
    scrollBottom,
    borCor
  },
  mixins: [
    routeLoading,
    responsitive,
    customTimeout
  ],
  props: {
    scope: {
      type: String,
      default: () => ''
    },
    defaultData: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      allCases: [],
      displayIDs: {
        case: [],
        dataset: []
      },
      dataset: {
        pipeline: 'WES'
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      users: [],
      tags: {
        tag: []
      },
      onSubmit: false,
      // search tag
      map: {
        tag: {}
      },
      query: {
        tag: ''
      },
      tag: {
        tag: {}
      },
      curTag: {
        tag: null
      },
      loading: {
        tag: false,
        tagAdd: false
      },
      searchTimer: {
        tag: []
      },
      // sample
      sample: {
        query: '',
        viewType: 'detail',
        listType: 'case',
        datas: {
          case: null,
          dataset: null
        },
        results: {
          case: [],
          dataset: []
        },
        tableOverflow: {
          case: false,
          dataset: false
        },
        emptyText: {
          case: 'No sample was selected to the dataset.'/* ___ */,
          dataset: ''
        },
        // page
        pageData: {
          selectedPage: {
            case: 1,
            dataset: 1
          },
          display: {
            case: 20,
            dataset: 20
          },
          total: {
            case: null,
            dataset: null
          },
          buttonRange: {
            case: 7,
            dataset: 7
          },
          pageJumpTo: {
            case: '',
            dataset: ''
          }
        },
        // sort
        sort: {
          case: {
            value: ['updated_at'],
            order: ['-desc']
          },
          dataset: {
            value: ['updated_at'],
            order: ['-desc']
          }
        }
      },
      // picture
      selectedPictureID: null,
      pictures: [],
      customPicture: null
    }
  },
  computed: {
    ...mapGetters([
      'modal'
    ]),
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    userOptions () {
      return this.users.map(user => ({ title: [user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : ''), value: user.id }))
    },
    pipelineOptions () {
      return Object.entries(datasetPipelineMap).map(([value, data]) => ({ ...data, value: value }))
    },
    totalPage () {
      this.sample.pageData.selectedPage = {
        case: 1,
        dataset: 1
      }
      return Object.entries(this.sample.pageData.total).reduce((s, [type, total]) => {
        let display = this.sample.pageData.display[type]
        return {
          ...s,
          [type]: Math.ceil(Math.min(total, display * 5000) / display)
        }
      }, {})
    },
    // sample
    selectedSampleSize () {
      return this.sample.results['case'].length + this.sample.results['dataset'].reduce((s, dataset) => s + (dataset.sample_size || 0), 0)
    },
    sampleFiltedDatas () {
      const filter = type => {
        let filtedData = this.sample.datas[type] || []
        filtedData = filtedData.filter(data => {
          return !this.sampleSelectedDataMap[type][data.id] && this.displayIDs[type].includes(data.id)
        })
        return filtedData
      }
      let filtedData = {
        case: filter('case'),
        dataset: filter('dataset')
      }
      return filtedData
    },
    sampleTableDatas () {
      const generator = type => {
        let tableDatas = [
          ...sortData(
            Object.values(this.sampleSelectedDataMap[type]),
            this.sample.sort[type].value.map(x => this.sampleSortMap[type][x] || x),
            this.sample.sort[type].order.map(x => x.replace('-', ''))
          ),
          ...this.sampleFiltedDatas[type]
        ]
        return groupBy(tableDatas, () => 'default').map(datas => ({ title: datas[0].group, isGroup: true, datas: datas }))
      }
      let tableDatas = {
        case: generator('case'),
        dataset: generator('dataset')
      }
      return tableDatas
    },
    sampleSelectedDataMap () {
      const generator = type => {
        return this.sample.results[type].reduce((map, data) => ({ ...map, [data.id]: { ...data, selected: true } }), {})
      }
      return {
        case: generator('case'),
        dataset: generator('dataset')
      }
    },
    sampleTableOptions () {
      return {
        case: [
          {
            value: '_SELECT',
            width: 50,
            class: () => ['center'],
            sortMap: null
          },
          {
            title: 'Case ID'/* ___ */,
            value: 'case_id',
            sortMap: { detail: undefined, list: null }[this.sample.viewType]
          },
          {
            title: 'Sex'/* ___ */,
            value: 'sex',
            width: 66,
            class: () => ['center'],
            display: value => ({ Male: 'M', Female: 'F', Unknown: 'U' }[value]),
            style: value => ({ Male: { color: '#003679' }, Female: { color: '#BE0F0F' }, Unknown: { color: '#333333' } }[value]),
            show: { detail: true, list: false }[this.sample.viewType]
          },
          {
            title: 'Age'/* ___ */,
            value: 'birth_year',
            width: 67,
            class: () => ['center'],
            display: value => value ? ((new Date()).getFullYear() - value + '') : null,
            show: { detail: true, list: false }[this.sample.viewType]
          },
          {
            title: 'Create'/* ___ */,
            value: 'created_at',
            width: 167,
            display: value => value ? dateFormat(new Date(value), 'yyyy/MM/dd hh:mm') : value,
            show: { detail: true, list: false }[this.sample.viewType]
          },
          {
            title: 'Modified'/* ___ */,
            value: 'updated_at',
            width: 167,
            display: value => value ? dateFormat(new Date(value), 'yyyy/MM/dd hh:mm') : value,
            show: { detail: true, list: false }[this.sample.viewType]
          }
        ],
        dataset: [
          {
            value: '_SELECT',
            width: 50,
            class: () => ['center'],
            sortMap: null
          },
          {
            title: 'Dataset name'/* ___ */,
            value: 'name',
            sortMap: { detail: undefined, list: null }[this.sample.viewType]
          },
          {
            title: 'Sample Size'/* ___ */,
            value: 'sample_size',
            width: 127,
            display: value => value ? toPriceString(value) : value,
            show: { detail: true, list: false }[this.sample.viewType]
          },
          {
            title: 'Owner'/* ___ */,
            value: 'user',
            width: 352,
            display: value => value ? [value.first_name, value.last_name].filter(x => x).join(' ') + (value.email ? ' (' + [value.email].filter(x => x).join(' ') + ')' : '') : value,
            sortValue: 'users.first_name',
            sortMap: dataset => dataset.user.first_name,
            show: { detail: true, list: false }[this.sample.viewType]
          },
          {
            title: 'Detail'/* ___ */,
            value: '_DETAIL',
            width: 78,
            class: () => ['center'],
            sortMap: null,
            show: { detail: true, list: false }[this.sample.viewType]
          }
        ]
      }
    },
    sampleSortMap () {
      return Object.keys(this.sampleTableOptions).reduce((result, key) => ({ ...result, [key]: this.sampleTableOptions[key].reduce((s, c) => ({ ...s, [c.value]: c.sortMap || c.value }), {}) }), {})
    },
    sampleSortValue () {
      return Object.keys(this.sampleTableOptions).reduce((result, key) => ({ ...result, [key]: this.sampleTableOptions[key].reduce((s, c) => ({ ...s, [c.value]: c.sortValue || c.value }), {}) }), {})
    },
    // static
    sampleListOptions () {
      return [
        {
          title: 'My selected samples (' + this.sample.results['case'].length + ')'/* ___ */,
          value: 'case'
        },
        {
          title: 'Community datasets'/* ___ */,
          value: 'dataset'
        }
      ]
    },
    formOptions () {
      return {
        field0: [
          {
            title: 'Owner'/* ___ */,
            value: 'user_id',
            type: 'custom',
            grid: 3,
            options: this.userOptions,
            validate: 'required'
          },
          {
            title: '　'/* ___ */,
            value: '',
            grid: 3
          }
        ],
        field1: [
          // 1
          {
            title: 'Dataset name'/* ___ */,
            value: 'name',
            type: 'input',
            grid: 2,
            onChange: value => {
              this.nameConfirm(value)
            },
            placeholder: () => 'Dataset name.'/* ___ */,
            validate: 'required'
          },
          {
            title: 'Add tags'/* ___ */,
            value: '_TAG',
            type: 'custom',
            grid: 1,
            placeholder: () => 'Name of tags'/* ___ */
          },
          {
            title: ''/* ___ */,
            value: '_TAGS',
            type: 'custom',
            grid: 3
          },
          // 2
          {
            title: 'Pipeline'/* ___ */,
            value: 'pipeline',
            type: this.dataset.id ? 'text' : 'select',
            grid: 2,
            options: this.pipelineOptions,
            placeholder: () => 'Pipeline'/* ___ */,
            validate: this.dataset.id ? '' : 'required',
            inputFormat: value => this.dataset.id ? (this.pipelineOptions.find(option => option.value === value) || {}).title : value
          },
          {
            title: 'Dataset description'/* ___ */,
            value: 'description',
            type: 'textarea',
            row: 4,
            grid: 4,
            placeholder: () => 'Note any description of the dataset.'/* ___ */
          }
        ]
      }
    },
    // unload alert
    sendData () {
      let sendData = {}
      sendData = {
        ...sendData,
        ...Object.entries(this.result).reduce((s, [k, v]) => ({ ...s, ...(k.startsWith('_') ? {} : { [k]: v }) }), {}),
        tags: this.tags['tag'],
        dataset_picture_file_id: this.selectedPictureID === 'custom' ? this.customPicture.id : this.selectedPictureID
      }
      if ((this.form || {}).sampleSelect) {
        sendData = {
          ...sendData,
          case_ids: this.sample.results['case'].map(result => result.id),
          community_dataset_ids: this.sample.results['dataset'].map(result => result.id)
        }
      }
      return sendData
    },
    // global
    fileTypeCheck () { return fileTypeCheck }
  },
  watch: {
    'defaultData' () {
      this.init(this.defaultData)
    },
    async 'sample.listType' () {
      if (!this.sample.datas[this.sample.listType]) {
        await this.sampleSearchDatas()
      }
    },
    'result.name' () {
      this.customValidate([], ['name'])
    },
    // search tag
    'query.tag' (nv) {
      this.getTag(nv, 'tag')
    },
    // sample
    async 'result.user_id' (nv, ov) {
      if (nv && ov) {
        this.setLoadingAction(true)
        await this.fetchDatasetCases()
        for (let option of this.sampleListOptions) {
          this.sample.results[option.value] = []
          this.displayIDs = {
            case: [],
            dataset: []
          }
          await this.sampleSearchDatas(true, option.value)
        }
        this.setLoadingAction(false)
      }
    },
    async 'result.pipeline' (nv, ov) {
      if (ov) {
        this.setLoadingAction(true)
        await this.fetchDatasetCases()
        for (let option of this.sampleListOptions) {
          this.sample.results[option.value] = []
          this.displayIDs = {
            case: [],
            dataset: []
          }
          await this.sampleSearchDatas(true, option.value)
        }
        this.setLoadingAction(false)
      }
    },
    'sample.query' () {
      this.customDelay(() => {
        for (let option of this.sampleListOptions) {
          this.sampleSearchDatas(true, option.value)
        }
      }, 300, 'queryChange')
    },
    'sampleTableDatas.case' () {
      this.getSampleTableOverflow('case')
    },
    'sampleTableDatas.dataset' () {
      this.getSampleTableOverflow('dataset')
    },
    // validate
    'selectedSampleSize' () {
      this.customValidate([], ['sample'])
    },
    // unload alert
    'sendData' (nv, ov) {
      if (JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.$emit('unloadAlert', true)
      }
    }
  },
  methods: {
    ...mapActions([
      'setLoadingAction',
      'setModalAction',
      'setModal2Action'
    ]),
    init (data) {
      this.dataset = {
        ...this.dataset,
        ...data,
        dataset_picture_file_id: (data.dataset_picture_file || {}).id
      }
      this.selectedPictureID = this.dataset.dataset_picture_file_id || this.selectedPictureID
      this.tags['tag'] = [...(this.dataset.tags || [])]
      setTimeout(() => this.$emit('unloadAlert', false))
    },
    async fetchData () {
      this.init(this.defaultData)
      if ((this.form || {}).roleSelect) {
        await this.fetchManagedUsers()
      }
      if (this.dataset.id) {
        await this.fetchCustomPicture()
      }
      await this.fetchDatasetPictureFiles()
      if ((this.form || {}).sampleSelect) {
        await this.fetchDatasetCases()
        await this.fetchSampleDatas(true, 'case')
        await this.fetchSampleDatas(true, 'dataset')
      }
    },
    async fetchManagedUsers () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getManagedUsers(config)
        let users = response.data.data
        this.users = users
        this.result = {
          ...this.result,
          user_id: users[0].id
        }
      } catch (error) {
        throw error
      }
    },
    async fetchCustomPicture () {
      try {
        let config = this.$ls.get('userInfo')
        let id = this.dataset.id
        let response = await getDatasetPictureFile(id, config)
        let customPicture = response.data.data
        this.customPicture = customPicture ? {
          ...customPicture,
          url: API_ROOT + 'global/files/download?file_id=' + customPicture.id + '&class_name=' + customPicture.class_name + '&access_token=' + config['access_token']
        } : this.customPicture
      } catch (error) {
        throw error
      }
    },
    async fetchDatasetPictureFiles () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getDatasetPictureFiles(config)
        let pictures = response.data.data
        pictures = pictures.filter(picture => picture.size && (picture.id !== (this.customPicture || {}).id)).map(picture => ({
          ...picture,
          url: API_ROOT + 'global/files/download?file_id=' + picture.id + '&class_name=' + picture.class_name + '&access_token=' + config['access_token']
        }))
        this.pictures = pictures
      } catch (error) {
        throw error
      }
    },
    async fetchDatasetCases () {
      try {
        let config = this.$ls.get('userInfo')
        let params = {
          q: this.sample.query || null,
          pipeline: this.dataset.id ? this.dataset.pipeline : this.result.pipeline,
          state: 'completed'
        }
        if ((this.form || {}).roleSelect) {
          params.user_id = this.result.user_id
        }
        let response = await getCreateDatasetCases(params, config)
        let cases = response.data.data
        cases = cases.map(caseData => {
          let phenotypeDatas = [
            ...caseData.phenotypes.hpo.map(phenotype => ({
              id: phenotype.hpo_id,
              name: phenotype.hpo_name,
              query: phenotype.hpo_id + ' ' + phenotype.hpo_name,
              type: 'hpo'
            })),
            ...caseData.phenotypes.disease_term.map(phenotype => ({
              id: phenotype.disease_id,
              name: phenotype.disease_name,
              query: phenotype.disease_id + ' ' + phenotype.disease_name,
              type: 'disease_term'
            }))
          ]
          return {
            ...caseData,
            phenotypeDatas: phenotypeDatas
          }
        })
        this.allCases = cases
      } catch (error) {
        // throw error
      }
    },
    async fetchSampleDatas (init = false, type) {
      try {
        let config = this.$ls.get('userInfo')
        let api = {
          case: this.getCreateDatasetCases,
          dataset: getFullAccessDatasets
        }[type]
        let params = {
          q: this.sample.query || null,
          type: type,
          pipeline: this.dataset.id ? this.dataset.pipeline : this.result.pipeline,
          state: 'completed'
        }
        if ((this.form || {}).roleSelect) {
          params.user_id = this.result.user_id
        }
        this.sample.pageData.selectedPage[type] && (params.page = this.sample.pageData.selectedPage[type])
        this.sample.pageData.display[type] && (params.items = this.sample.pageData.display[type])
        this.sample.sort[type].value[0] && (params.order_by = (this.sampleSortValue[type][this.sample.sort[type].value[0]] || this.sample.sort[type].value[0]) + ':' + this.sample.sort[type].order[0].replace(/^-/, ''))
        let response = await api(params, config)
        let sampleDatas = response.data.data || []
        let total = response.data.count || 0
        this.sample.datas[type] = [
          ...(this.sample.datas[type] || []),
          ...sampleDatas
        ]
        this.sample.pageData.total[type] = {
          'case': this.sample.pageData.total[type],
          'dataset': sampleDatas.length
        }[type]
        this.displayIDs[type] = {
          'case': [],
          'dataset': sampleDatas.map(data => data.id)
        }[type]
        // this.sample.pageData.selectedPage[type] += (sampleDatas.length ? 1 : 0)
        return !!(sampleDatas.length && (total > this.sample.datas[type].length))
      } catch (error) {
        if (init) {
          throw error
        } else {
          // this.addToast('error', !error.response ? error.message : error.response.data.result.message)
          return false
        }
      }
    },
    async afterSetData () {
      let id = this.dataset.dataset_picture_file_id || this.pictures[0].id
      this.selectedPictureID = (this.pictures.find(picture => picture.id === id) || {}).id || 'custom'
      setTimeout(() => this.$emit('unloadAlert', false))
    },
    async getCreateDatasetCases (params, config) {
      let response = { data: {} }
      let results = this.allCases
      let order = params.order_by ? (params.order_by).split(':') : null
      let pageData = {
        selectedPage: this.sample.pageData.selectedPage[params.type],
        display: this.sample.pageData.display[params.type]
      }
      params.q && (results = results.filter(result => result.case_id.includes(params.q)))
      order && (results = sortData(results, order[0], order[1]))
      results = results.filter((_, index) => (
        index >= ((pageData.selectedPage - 1) * pageData.display) &&
        index < ((pageData.selectedPage - 0) * pageData.display)
      ))
      response.data = {
        data: results,
        count: this.allCases.length
      }
      return response
    },
    async sampleSearchDatas (reset = false, type) {
      reset && this.setLoadingAction(true)
      type = type || this.sample.listType
      if (reset) {
        this.sample.datas[type] = []
        this.sample.pageData.selectedPage[type] = 1
        let result = await (new Promise(resolve => {
          setTimeout(async () => {
            let result = await this.fetchSampleDatas(false, type)
            resolve(result)
          }, 300)
        }))
        reset && this.setLoadingAction(false)
        return result
      } else {
        // let result = await this.fetchSampleDatas(false, type)
        // reset && this.setLoadingAction(false)
        // return result
        return false
      }
    },
    getSampleTableOverflow (type) {
      setTimeout(() => {
        try {
          let scrollContainer = this.$refs['custom-table-scroll-' + type][0].$el
          if (scrollContainer) {
            this.sample.tableOverflow[type] = scrollContainer.scrollHeight > scrollContainer.offsetHeight
          }
        } catch (error) {}
      })
    },
    sampleTableOnSelect (type, datas, value) {
      if (value === 'all') {
        if (!this.sampleFiltedDatas[type].some(data => !this.sampleSelectedDataMap[type][data.id])) {
          datas = this.sample.results[type]
          value = false
        } else {
          datas = this.sampleFiltedDatas[type]
          value = true
        }
      }
      let dataMap = datas.reduce((map, data) => ({ ...map, [data.id]: data }), {})
      this.sample.results[type] = value ? [...datas.filter(data => !this.sampleSelectedDataMap[type][data.id]), ...this.sample.results[type]] : this.sample.results[type].filter(result => !dataMap[result.id])
      this.displayIDs[type] = {
        case: this.sample.results[type].map(result => result.id),
        dataset: this.sample.datas[type].map(result => result.id)
      }[type]
    },
    sampleTableSortBy (value, type) {
      let position = this.sample.sort[type].value.indexOf(value)
      if (position === 0) {
        let order =
          this.sample.sort[type].order[position] === '-asc' ? '-desc' : '-asc'
        this.sample.sort[type].order.splice(position, 1)
        this.sample.sort[type].order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sample.sort[type].order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sample.sort[type].value.splice(position, 1)
        this.sample.sort[type].order.splice(position, 1)
        this.sample.sort[type].value.unshift(value)
        this.sample.sort[type].order.unshift(order || '-asc')
      }
      this.sampleSearchDatas(true, type)
    },
    async sampleOpenDatasetDetail (dataset) {
      let action = this.modal.action ? this.setModal2Action : this.setModalAction
      try {
        let config = this.$ls.get('userInfo')
        let id = dataset.id
        let response = await getDatasetCases(id, config)
        let cases = response.data.data
        cases = cases.map(caseData => ({
          ...caseData.case
        }))
        action({
          action: 'datasetDetail',
          width: '912px',
          height: (this.windowHeight - 160) + 'px',
          customStyles: {
            'max-width': 'calc(100% - 40px)'
          },
          param: {
            dataset: dataset,
            cases: cases
          }
        })
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    },
    sampleOpenDatasetSelectCase () {
      let action = this.modal.action ? this.setModal2Action : this.setModalAction
      let cases = this.allCases.filter(caseData => !this.displayIDs['case'].includes(caseData.id)) || []
      action({
        action: 'datasetSelectCase',
        width: '1208px',
        height: cases.length ? (this.windowHeight - 160) + 'px' : 'auto',
        customStyles: {
          'max-width': 'calc(100% - 40px)'
        },
        param: {
          cases: cases
        },
        callback: async result => {
          if (result) {
            let displayIDs = [
              ...this.displayIDs['case'],
              ...result
            ]
            this.sample.pageData.total['case'] = displayIDs.length
            this.sampleTableOnSelect('case', this.allCases.filter(caseData => displayIDs.includes(caseData.id)), true)
          }
        }
      })
    },
    async getTag (query, target) {
      const queryMap = {
      }
      query = (queryMap[target] || (x => x))(query)
      if (this.curTag[target] !== query) {
        this.tag[target] = {}
        if (this.searchTimer[target]) {
          clearTimeout(this.searchTimer[target])
        }
        this.searchTimer[target] = setTimeout(async () => {
          if (!this.map[target][query] && query) {
            this.loading[target] = true
            this.setLoadingAction(true)
            try {
              let datas = await this.getDataApi(query, target)
              this.map[target] = {
                ...this.map[target],
                [query]: {
                  items: datas || []
                }
              }
            } catch (error) {
              this.addToast('error', !error.response ? error.message : error.response.data.result.message)
            }
            this.loading[target] = false
            this.setLoadingAction(false)
          }
          this.tag[target] = this.map[target][query] || {}
        }, 500)
      }
    },
    async getDataApi (query, target) {
      const seed = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'p', 'Q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '2', '3', '4', '5', '6', '7', '8', '9']
      const getRandomDatas = () => query.length <= 5 ? (new Array(10)).fill('').map(() => {
        let prefix = (new Array(Math.floor(Math.random() * 5))).fill('').map(() => seed[Math.floor(Math.random() * seed.length)]).join('')
        let suffix = (new Array(Math.floor(Math.random() * 5))).fill('').map(() => seed[Math.floor(Math.random() * seed.length)]).join('')
        return prefix + query + suffix
      }) : []
      let getData = new Promise(resolve => {
        setTimeout(() => {
          let datas = getRandomDatas()
          resolve(datas)
        }, 300)
      })
      let result = await getData
      return result
    },
    addTag (target, type) {
      let data = this.query[target]
      if (data && !this.loading[target + 'Add']) {
        this.loading[target + 'Add'] = true
        switch (target) {
          case 'tag': {
            if (data) {
              this.tags[target].push(data)
              this.query[target] = ''
            } else if (!this.onError && !this.onSubmit && !data && type !== 'button') {
            }
            break
          }
          default: {}
        }
        this.query[target] = ''
        this.loading[target + 'Add'] = false
      }
    },
    async selectCustomPicture (e) {
      let action = this.modal.action ? this.setModal2Action : this.setModalAction
      let file = e.target.files[0]
      let url = (await imageReader([file]))[0]
      action({
        action: 'imageCropper',
        width: '616px',
        param: {
          url: url
        },
        callback: async result => {
          if (result) {
            this.customPicture = {
              id: 'custom',
              name: file.name,
              url: result.url,
              file: result.file,
              class_name: 'DatasetPictureFile'
            }
          }
        }
      })
      e.target.value = ''
    },
    onEvent (e, c) {
      if (['tag', 'send'].includes(e)) {
        if (c && c !== 'all') {
          let id = c.id || (this.users.find(user => c === [user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : '')) || {}).id
          this.result.user_id = id || this.result.user_id
        } else {
          this.result.user_id = -1
        }
      }
    },
    formOnChange (field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
      }
      for (let col of cols || Object.keys(this.dataset)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async nameConfirm (name) {
      try {
        let config = this.$ls.get('userInfo')
        let params = {
          name: name
        }
        if ((this.form || {}).roleSelect) {
          params.user_id = this.result.user_id
        }
        let response = await getDatasetExistingState(params, config)
        let result = response.data.data
        if (!result) {
          this.alerts = {
            ...this.alerts,
            name: null
          }
        } else {
          throw new Error()
        }
      } catch (error) {
        this.alerts = {
          ...this.alerts,
          name: {
            type: 'error',
            msg: 'Name has already been taken.'/* ___ */
          }
        }
      }
    },
    sampleValidate () {
      if (this.selectedSampleSize > 0) {
        return true
      } else {
        this.alerts = {
          ...this.alerts,
          sample: {
            type: 'error',
            msg: 'Sample size is too small.'/* ___ */
          }
        }
        return false
      }
    },
    async validateSubmit () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if ((this.form || {}).sampleSelect) {
        result['sample'] = this.sampleValidate()
      }
      if (!Object.values(result).includes(false)) {
        return true
      }
      this.onSubmit = false
    },
    async submit () {
      let data = this.sendData
      let customPicture = this.customPicture
      return { data: data, customPicture: customPicture }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/dataset/base.vue